import { InjectionToken } from '@angular/core';

export const BASE_API_HREF = new InjectionToken<string>('base.api.href');
